import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RefCodesSaveRequest } from 'src/app/model/reverse/ref-code.model';
import { LookUpKeyValueforDomainList, LookupMenuUpdateArr, LookUpName, LookupRequestMenu, LookupValueReq, transParamsRes, transCodesReq } from '../../model/lov';
import { v4 as uuid } from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class RefCodeService {

  editRow: any = '';
  editRow$ = new BehaviorSubject(this.editRow);
  currentAction = '';
  currentAction$ = new BehaviorSubject(this.currentAction);
  currentPopupAction = '';
  currentPopupAction$ = new BehaviorSubject(this.currentPopupAction);
  currentData = null;
  currentData$ = new BehaviorSubject(this.currentData);
  lookupDataList = LookUpKeyValueforDomainList;
  currentLookupDataList = new BehaviorSubject<LookUpKeyValueforDomainList>(null);
  currentShipmentLookupDataList = new BehaviorSubject<LookUpKeyValueforDomainList>(null); 

  constructor(private http: HttpClient) { }

  // searchRefCodeByDomain(
  //   refWhsId: string,
  //   refConfigCusId: string,
  //   refDomain: string,
  //   refDomainCode: string,
  //   refDeletedFlag: string
  // ): Observable<any> {
  //   let params = new HttpParams();
  //   params = params.append('refWhsId', refWhsId);
  //   params = params.append('refConfigCusId', refConfigCusId);
  //   params = params.append('refDomain', refDomain);
  //   params = params.append('refDomainCode', encodeURIComponent(refDomainCode));
  //   params = params.append('refDeletedFlag', refDeletedFlag);

  //   const httpOptions = {
  //     params
  //   };

  //   return this.http.get(environment.apiRlogRefCodesURL, httpOptions);
  // }

  getRefCodesOfDomain(refWhsId, refConfigCusId, refDomainList) {
    return this.http.get(
      environment.apiRlogRefCodesURL +
      '/getrefcodes/' +
      refWhsId +
      '/' +
      refConfigCusId +
      '/' +
      refDomainList
    );
  }

  // saveRefCodes(refCodeSaveRequest: RefCodesSaveRequest) {
  //   return this.http.post(
  //     environment.apiRlogRefCodesURL + '/saverefcodes',
  //     refCodeSaveRequest
  //   );
  // }

  addLookupValue(
    domainList: string[],
    domainCode?: string,
    codeActive?: string,
    facility?: string,
    customerId?: string,
    buId?: string,
  ): Observable<LookUpKeyValueforDomainList> {
    console.log(domainCode)
    const requestParameters =
    typeof domainList !== undefined &&
    typeof domainCode === undefined || domainCode === ''
      ? {
        lookupNames: domainList,
        fcyId: facility.toString() ? facility : '0',
        cusId: customerId.toString() ? customerId : '0',
        buId: buId.toString() ? buId : '0'
      }
      : {
          lookupNames: domainList,
          lookupCode: domainCode,
          fcyId: facility.toString() ? facility : '0',
          cusId: customerId.toString() ? customerId : '0',
          buId: buId.toString() ? buId : '0'
        };

    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid()
      },
      params: requestParameters
    };
    return this.http.get<LookUpKeyValueforDomainList>(
      environment.apiLookupURL,
      httpOptions
    );
  }

  getKeyValue(
    domainList: string[],
    domainCode?: string,
    codeActive?: string,
    facility?: string,
    customerId?: string,
    buId?: string,
  ): Observable<LookUpKeyValueforDomainList> {
    const requestParameters =
    typeof domainList !== undefined &&
    typeof domainCode === undefined || domainCode === ''
      ? {
        active: codeActive ? codeActive : 'Y',
        lookupNames: domainList,
        fcyId: facility ? facility : '0',
        cusId: customerId ? customerId : '0',
        buId: buId ? buId : '0'
      }
      : {
          lookupNames: domainList,
          lookupCode: domainCode,
          active: codeActive ? codeActive : 'Y',
          fcyId: facility ? facility : '0',
          cusId: customerId ? customerId : '0',
          buId: buId ? buId : '0'
        };

    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid()
      },
      params: requestParameters
    };
    return this.http.get<LookUpKeyValueforDomainList>(
      environment.apiLookupURL,
      httpOptions
    );
  }

  getLookupKeyValues(
    domainList: string[],
    domainCode?: string,
    codeActive?: string,
    facility?: string,
    customerId?: string,
    buId?: string,
  ): Observable<LookUpKeyValueforDomainList> {
    const requestParameters =
    typeof domainList !== undefined &&
    typeof domainCode === undefined || domainCode === ''
      ? {
        active: codeActive === 'N' ? 'N' : codeActive === 'Y' ? 'Y' : 'N',
        lookupNames: domainList,
        fcyId: facility ? facility : '0',
        cusId: customerId ? customerId : '0',
        buId: buId ? buId : '0'
      }
      : {
          lookupNames: domainList,
          lookupCode: domainCode,
          active: codeActive === 'N' ? 'N' : codeActive === 'Y' ? 'Y' : 'N',
          fcyId: facility ? facility : '0',
          cusId: customerId ? customerId : '0',
          buId: buId ? buId : '0'
        };

    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid()
      },
      params: requestParameters
    };
    return this.http.get<LookUpKeyValueforDomainList>(
      environment.apiLookupURL,
      httpOptions
    );
  }

  getFcyLookupKeyValues(
    domainList: string[],
    domainCode?: string,
    codeActive?: string,
    facilityId?: string,
  ): Observable<any> {

    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid()
      },
      params: {
        lookupNames: domainList,
        lookupCode: domainCode,
        active: codeActive === 'N' ? 'N' : codeActive === 'Y' ? 'Y' : 'N',
        fcyId: facilityId ? facilityId : '0',
        cusId: '0',
        buId: '0',
        ignoreLookupValueMatch: 'false'
      }
    };
    return this.http.get<any>(
      environment.apiLookupURL,
      httpOptions
    );
  }

  getFilteredLookups(
    domainList: string,
    domainCode?: string,
    codeActive?: string,
    facility?: string,
    customerId?: string,
    buId?: string,
  ): Observable<LookUpKeyValueforDomainList> {
    const requestParameters =
      domainCode === '' || domainCode === undefined || domainCode === null
        ? {
          active: codeActive === 'N' ? 'N' : codeActive === 'Y' ? 'Y' : 'N',
          lookupName: domainList,
          fcyId: facility ? facility : '0',
          cusId: customerId ? customerId : '0',
          buId: buId ? buId : '0'
        }
        : {
          lookupName: domainList,
          lookupCode: domainCode ? domainCode : null,
          active: codeActive === 'N' ? 'N' : codeActive === 'Y' ? 'Y' : 'N',
          fcyId: facility ? facility : '0',
          cusId: customerId ? customerId : '0',
          buId: buId ? buId : '0'
        };

    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid()
      },
      params: requestParameters
    };
    return this.http.get<LookUpKeyValueforDomainList>(
      environment.apiLookupNameValueURL,
      httpOptions
    );
  }

  createLookupName(createLookupNameReq: LookUpName): Observable<LookUpKeyValueforDomainList> {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid()
      },
    };
    return this.http.post<LookUpKeyValueforDomainList>(
      environment.apiLookupURL,
      JSON.stringify(createLookupNameReq),
      httpOptions
    );
  }

  createLookupValues(lookupValueReq: LookupValueReq): Observable<LookUpKeyValueforDomainList> {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid()
      },
    };
    return this.http.post<LookUpKeyValueforDomainList>(
      environment.apiLookupURL+"/lookupvalues",
      JSON.stringify(lookupValueReq),
      httpOptions
    );
  }

  updateLookupValues(lookupValueReq: LookupValueReq): Observable<LookUpKeyValueforDomainList> {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid()
      },
    };
    return this.http.put<LookUpKeyValueforDomainList>(
      environment.apiLookupURL+"/lookupvalues",
      JSON.stringify(lookupValueReq),
      httpOptions
    );
  }


  patchUpdateLookupValues(lookupValueReq: LookupValueReq): Observable<LookUpKeyValueforDomainList> {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid()
      },
    };
    return this.http.patch<LookUpKeyValueforDomainList>(
      environment.apiLookupURL+"/lookupvalues",
      JSON.stringify(lookupValueReq),
      httpOptions
    );
  }

  updateallLookupValueByLookupId(req: any): Observable<any> {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid(),
        FSCUSER: localStorage.getItem('USER-ID'),
      },
    }
      return this.http.patch<any>(environment.apiLookupURL + '/lookupvalues/grouped', JSON.stringify(req),httpOptions);
   }
   
  getKeyValueActive(LookupRequest: LookupRequestMenu): Observable<LookUpKeyValueforDomainList> {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid()
      },
      params: {
        active : LookupRequest.active ? LookupRequest.active : '',
        fcyId: LookupRequest.fcyId,
        cusId: LookupRequest.cusId,
        buId: LookupRequest.buId,
        lookupNames: LookupRequest.lookupNames,

      }
    };
    return this.http.get<LookUpKeyValueforDomainList>(environment.apiLookupURL, httpOptions);
  }

  updateToggleLookupValues(LookupRequest: LookupMenuUpdateArr): Observable<LookUpKeyValueforDomainList> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      APPID: environment.apiBussServAPPID,
      UUID: uuid(),
      FSC_USER: localStorage.getItem('USERID'),
    });

    const options = { headers };
    return this.http.put<LookUpKeyValueforDomainList>(environment.apiLookupURL + '/lookupvalues', JSON.stringify(LookupRequest), options);
  }

  getTransParamsKeyValue(transCodesReq: transCodesReq): Observable<transParamsRes> {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid()
      },
      params: {
        fcyId: transCodesReq.fcyId ? transCodesReq.fcyId : '0',
        custId: transCodesReq.custId ? transCodesReq.custId : '0',
        buId: transCodesReq.buId ? transCodesReq.buId : '0',
        transCode: transCodesReq.transCode
      }
    };
    return this.http.get<transParamsRes>(environment.apiTaskURL + '/rf/txparam', httpOptions);
  }
}
